module.exports = "276c35ee62879fedd57db91f553db94a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-leg-r.png
// module id = 67
// module chunks = 0